import React, { useState } from 'react';
import Loading from '../Loading';
import {
    getStorage,
    ref,
    uploadBytesResumable,
    getDownloadURL,
  } from "firebase/storage";
  import { getAuth } from "firebase/auth";
  import { v4 as uuidv4 } from "uuid";
  import { addDoc, collection, serverTimestamp } from "firebase/firestore";
 
  import { useNavigate } from "react-router-dom";
  import { db } from "../../firebase"
  import Card from "react-bootstrap/Card"
  import Container from 'react-bootstrap/Container';
  import Row from 'react-bootstrap/Row';
  import Col from 'react-bootstrap/Col';
  import Form from 'react-bootstrap/Form';
  

  const CreateListing = () => {
	const navigate = useNavigate();
  const auth = getAuth();
  const [geolocationEnabled, setGeolocationEnabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    type: "rent",
    name: "",
    bedrooms: 1,
    bathrooms: 1,
    parking: false,
    furnished: false,
    address: "",
    zipcode:"",
    description: "",
    offer: false,
    regularPrice: 0,
    discountedPrice: 0,
    latitude: 0,
    longitude: 0,
    images: {},
  });
  const {
    type,
    name,
    bedrooms,
    bathrooms,
    parking,
    address,
    zipcode,
    furnished,
    description,
    offer,
    regularPrice,
    discountedPrice,
    latitude,
    longitude,
    images,
  } = formData;
  function onChange(e) {
    let boolean = null;
    if (e.target.value === "true") {
      boolean = true;
    }
    if (e.target.value === "false") {
      boolean = false;
    }
    // Files
    if (e.target.files) {
      setFormData((prevState) => ({
        ...prevState,
        images: e.target.files,
      }));
    }
    // Text/Boolean/Number
    if (!e.target.files) {
      setFormData((prevState) => ({
        ...prevState,
        [e.target.id]: boolean ?? e.target.value,
      }));
    }
  }
  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    if (+discountedPrice >= +regularPrice) {
      setLoading(false);
      alert("Discounted price needs to be less than regular price");
      return;
    }
    if(!zipcode)alert("Please enter zipcode")
    if (images.length > 6) {
      setLoading(false);
      alert("maximum 6 images are allowed");
      return;
    }
    let geolocation = {};
    let location;
    if (geolocationEnabled) {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${process.env.REACT_APP_GEOCODE_API_KEY}`
      );
      const data = await response.json();
      console.log(data);
      geolocation.lat = data.results[0]?.geometry.location.lat ?? 0;
      geolocation.lng = data.results[0]?.geometry.location.lng ?? 0;

      location = data.status === "ZERO_RESULTS" && undefined;

      if (location === undefined) {
        setLoading(false);
        alert("please enter a correct address");
        return;
      }
    } else {
      geolocation.lat = latitude;
      geolocation.lng = longitude;
    }

    async function storeImage(image) {
      return new Promise((resolve, reject) => {
        const storage = getStorage();
        const filename = `${auth.currentUser.uid}-${image.name}-${uuidv4()}`;
        const storageRef = ref(storage, filename);
        const uploadTask = uploadBytesResumable(storageRef, image);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log("Upload is " + progress + "% done");
            switch (snapshot.state) {
              case "paused":
                console.log("Upload is paused");
                break;
              case "running":
                console.log("Upload is running");
                break;
            }
          },
          (error) => {
            // Handle unsuccessful uploads
            reject(error);
          },
          () => {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              resolve(downloadURL);
            });
          }
        );
      });
    }

    const imgUrls = await Promise.all(
      [...images].map((image) => storeImage(image))
    ).catch((error) => {
      setLoading(false);
      alert("Images not uploaded");
      return;
    });

    const formDataCopy = {
      ...formData,
      imgUrls,
      geolocation,
      timestamp: serverTimestamp(),
      userRef: auth.currentUser.uid,
    };
    delete formDataCopy.images;
    !formDataCopy.offer && delete formDataCopy.discountedPrice;
    delete formDataCopy.latitude;
    delete formDataCopy.longitude;
    const docRef = await addDoc(collection(db, "listings"), formDataCopy);
    setLoading(false);
    alert("Listing created");
    navigate(`/${formDataCopy.type}/${docRef.id}`);
  }

  if (loading) {
    return <Loading />;
  }
	return (
        <div>
			<h1>Sell Or Rent Your Home</h1>
        
         <main className="max-w-md px-2 mx-auto">
         <h1 className="text-3xl text-center mt-6 font-bold">Create a Listing</h1>
         <Card className="createListing">
         <Form onSubmit={onSubmit}>
           <p className="text-lg mt-6 font-semibold">Sell / Rent</p>
           <div className="flex">
             
             <button
               type="button"
               id="type"
               value="sale"
               onClick={onChange}
               className={`${
                type === "rent"
                  ? "btn btn-primary"
                  : "btn btn-light"
              }`}
             >
               sell
             </button>
             <button
               type="button"
               id="type"
               value="rent"
               onClick={onChange}
               className={`${
                type === "rent"
                  ? "btn btn-light"
                  : "btn btn-primary"
              }`}
             >
               rent
             </button>
           </div>
           <p >Name</p>
           <input
             type="text"
             id="name"
             value={name}
             onChange={onChange}
             placeholder="Name"
             maxLength="32"
             minLength="10"
             required
             className="form-control"
           />
           <div className="flex space-x-6 mb-6">
             <div>
               <p className="text-lg font-semibold">Beds</p>
               <input
                 type="number"
                 id="bedrooms"
                 value={bedrooms}
                 onChange={onChange}
                 min="1"
                 max="50"
                 required
                 className="form-control"
               />
             </div>
             <div>
               <p className="text-lg font-semibold">Baths</p>
               <input
                 type="number"
                 id="bathrooms"
                 value={bathrooms}
                 onChange={onChange}
                 min="1"
                 max="50"
                 required
                 className="form-control"
               />
             </div>
           </div>
           <p className="text-lg mt-6 font-semibold">Parking spot</p>
           <div className="flex">
             <button
               type="button"
               id="parking"
               value={true}
               onClick={onChange}
               className={`${
                 parking ? "btn btn-light"
                 : "btn btn-primary"
               }`}
             >
               Yes
             </button>
             <button
               type="button"
               id="parking"
               value={false}
               onClick={onChange}
               className={`${
                !parking ? "btn btn-light"
                : "btn btn-primary"
              }`}
             >
               no
             </button>
           </div>
           <p className="text-lg mt-6 font-semibold">Furnished</p>
           <div className="flex">
             <button
               type="button"
               id="furnished"
               value={true}
               onClick={onChange}
               className={`${
                 furnished ? "btn btn-light"
                 : "btn btn-primary"
               }`}
             >
               yes
             </button>
             <button
               type="button"
               id="furnished"
               value={false}
               onClick={onChange}
               className={`${
                !furnished ? "btn btn-light"
                : "btn btn-primary"
              }`}
             >
               no
             </button>
           </div>
           <p className="text-lg mt-6 font-semibold">Address</p>
           <textarea
             type="text"
             id="address"
             value={address}
             onChange={onChange}
             placeholder="Address"
             required
             className="form-control"
           />
            <p >Zipcode</p>
           <input
             type="text"
             id="zipcode"
             value={zipcode}
             onChange={onChange}
             placeholder="zipcode"
             maxLength="10"
             minLength="5"
             required
             className="form-control"
           />

           {!geolocationEnabled && (
             <div className="flex space-x-6 justify-start mb-6">
               <div className="">
                 <p className="text-lg font-semibold">Latitude</p>
                 <input
                   type="number"
                   id="latitude"
                   value={latitude}
                   onChange={onChange}
                   required
                   min="-90"
                   max="90"
                   className="w-full px-4 py-2 text-xl text-gray-700 bg-white border border-gray-300 rounded transition duration-150 ease-in-out focus:bg-white focus:text-gray-700 focus:border-slate-600 text-center"
                 />
               </div>
               <div className="">
                 <p className="text-lg font-semibold">Longitude</p>
                 <input
                   type="number"
                   id="longitude"
                   value={longitude}
                   onChange={onChange}
                   required
                   min="-180"
                   max="180"
                   className="form-control"
                 />
               </div>
             </div>
           )}
           <p className="text-lg font-semibold">Description</p>
           <textarea
             type="text"
             id="description"
             value={description}
             onChange={onChange}
             placeholder="Description"
             required
             className="form-control"
           />
           <p className="text-lg font-semibold">Offer</p>
           <div className="flex mb-6">
             <button
               type="button"
               id="offer"
               value={true}
               onClick={onChange}
               className={`${
                 offer ? "btn btn-light"
                 : "btn btn-primary"
               }`}
             >
               yes
             </button>
             <button
               type="button"
               id="offer"
               value={false}
               onClick={onChange}
               className={`${
                !offer ? "btn btn-light"
                : "btn btn-primary"
              }`}
             >
               no
             </button>
           </div>
           <div className="flex items-center mb-6">
             <div className="">
               <p className="text-lg font-semibold">Regular price</p>
               <div className="flex w-full justify-center items-center space-x-6">
                 <input
                   type="number"
                   id="regularPrice"
                   value={regularPrice}
                   onChange={onChange}
                   min="50"
                   max="400000000"
                   required
                   className="form-control"
                 />
                 {type === "rent" && (
                   <div className="">
                     <p className="text-md w-full whitespace-nowrap">$ / Month</p>
                   </div>
                 )}
               </div>
             </div>
           </div>
           {offer && (
             <div className="flex items-center mb-6">
               <div className="">
                 <p className="text-lg font-semibold">Discounted price</p>
                 <div className="flex w-full justify-center items-center space-x-6">
                   <input
                     type="number"
                     id="discountedPrice"
                     value={discountedPrice}
                     onChange={onChange}
                     min="50"
                     max="400000000"
                     required={offer}
                     className="form-control"
                   />
                   {type === "rent" && (
                     <div className="">
                       <p className="text-md w-full whitespace-nowrap">
                         $ / Month
                       </p>
                     </div>
                   )}
                 </div>
               </div>
             </div>
           )}
           <div className="mb-6">
             <p className="text-gray-600">
               The first image will be the cover (max 6)
             </p>
             <label for="formFileMultiple" class="form-label">Upload Images</label>
             <input
               type="file"
               id="images"
               onChange={onChange}
               accept=".jpg,.png,.jpeg,.webp"
               multiple
               required
               className="form-control"
             />
           </div>
           <br/>
           <button
             type="submit"
             className="btn btn-success"
           >
             Create Listing
           </button>
         </Form>
         </Card>
       </main>
       </div>
    )
};

export default CreateListing;